import { jsx as _jsx } from "react/jsx-runtime";
import { createRef, Component } from 'react';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import { stripDiacritics } from 'UIComponents/utils/Diacritics';
import UILink from 'UIComponents/link/UILink';
import { MobileDropdown } from 'signup-ui-full-screen-search/components/MobileDropdown';
import IndustryService from '../services/IndustryService';
export class IndustryInput extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isLoading: true
    };
    this.inputFieldRef = /*#__PURE__*/createRef();

    this.getSortedMatchedIndustryNames = (searchValue, industryOptions) => {
      const industryMatch = industryOptions.filter(option => {
        return stripDiacritics(option.text.toLowerCase()).includes(searchValue);
      });
      return industryMatch.sort((a, b) => {
        const aStart = a.text.toLowerCase().indexOf(searchValue);
        const bStart = b.text.toLowerCase().indexOf(searchValue);

        if (aStart === bStart) {
          return a.text.length - b.text.length;
        }

        return aStart - bStart;
      });
    };

    this.loadIndustryOptions = userInput => {
      return new Promise(resolve => {
        if (!userInput.length) {
          resolve(null);
        }

        IndustryInput.fetchIndustries().then(industries => {
          resolve({
            options: this.getMatchingIndustries(userInput, industries)
          });
        }).catch(error => {
          this.props.onFetchError(error);
          resolve({
            options: this.getMatchingIndustries(userInput, [])
          });
        });
      });
    };

    this.onSelect = e => {
      const {
        onSelectedOptionChange
      } = this.props;
      const value = e.target.value;
      onSelectedOptionChange(value);
    };

    this.onInputChange = e => {
      const {
        onInputValueChange
      } = this.props;
      const value = e.target.value;
      onInputValueChange(value);
    };

    this.onSelectMobile = e => {
      const {
        onSelectedOptionChange
      } = this.props;
      onSelectedOptionChange(e);
    };

    this.onInputChangeMobile = e => {
      const {
        onInputValueChange
      } = this.props;
      onInputValueChange(e);
    };
  }

  //Fetches all industry options.
  static fetchIndustries() {
    if (!IndustryInput.ALL_OPTIONS) {
      IndustryInput.ALL_OPTIONS = IndustryService.available();
    }

    return IndustryInput.ALL_OPTIONS;
  }

  componentDidMount() {
    IndustryInput.fetchIndustries().catch(error => {
      this.props.onFetchError(error);
    }).finally(() => {
      this.setState({
        isLoading: false
      });

      if (this.props.autoFocus) {
        setTimeout(() => {
          if (this.inputFieldRef.current) {
            this.inputFieldRef.current.focus();
          }
        }, this.props.focusTimeout);
      }
    });
  }

  //Gets all matching given industries for a given user input.
  getMatchingIndustries(userInput, options = []) {
    const {
      otherOption = {
        text: I18n.text('industryInput.otherOption.text'),
        help: I18n.text('industryInput.otherOption.help')
      },
      shouldUseRelevantSearch
    } = this.props;
    let matchingOptions;

    if (shouldUseRelevantSearch) {
      matchingOptions = this.getSortedMatchedIndustryNames(userInput.toLowerCase(), options);
    } else {
      matchingOptions = options.filter(option => stripDiacritics(option.text.toLowerCase()).includes(userInput.toLowerCase()));
    }

    if (matchingOptions.length === 0) {
      matchingOptions.push(Object.assign({}, otherOption, {
        value: 'other'
      }));
    }

    return matchingOptions;
  } // Loads the available list of industries.


  //Renders the component
  render() {
    const {
      placeholder = I18n.text('industryInput.placeholder'),
      predicted,
      predictedSelectedValue,
      predictedOptions,
      onShowAll,
      showAllLabel = I18n.text('industryInput.showall'),
      inputValue,
      isMobile,
      illustrationCaption,
      illustrationName,
      otherOption,
      searchPlaceholder,
      isFullScreenOpen,
      shouldShowPlaceholder
    } = this.props; // UISelect props to apply

    const {
      autoFocus,
      readOnly,
      disabled
    } = this.props;

    if (isMobile) {
      return /*#__PURE__*/_jsx(MobileDropdown, {
        disabled: this.state.isLoading || disabled,
        illustrationCaption: illustrationCaption,
        illustrationName: illustrationName,
        illustrationWidth: 100,
        isFullScreenOpen: isFullScreenOpen,
        noMatchesOption: otherOption,
        loadOptions: this.loadIndustryOptions,
        searchPlaceholder: searchPlaceholder,
        selected: inputValue,
        seleniumKey: 'industry',
        showOptionsWhenNullSearchValue: false,
        onInputChange: this.onInputChangeMobile,
        onSelectChange: this.onSelectMobile
      });
    }

    return /*#__PURE__*/_jsx(UISelect, Object.assign({
      autoFocus: autoFocus,
      buttonUse: 'form',
      inputRef: this.inputFieldRef,
      readOnly: readOnly,
      "data-selenium": "industry",
      anchorType: predicted ? 'auto' : 'input',
      defaultValue: predicted ? predictedSelectedValue : undefined,
      disabled: this.state.isLoading || disabled,
      dropdownFooter: predicted && /*#__PURE__*/_jsx(UILink, {
        onClick: onShowAll,
        children: showAllLabel
      }),
      filterOptions: predicted,
      inputValue: inputValue,
      loadOptions: !predicted ? this.loadIndustryOptions : undefined,
      options: predicted ? predictedOptions : []
    }, shouldShowPlaceholder && {
      placeholder
    }, {
      onInputValueChange: this.onInputChange,
      onSelectedOptionChange: this.onSelect
    }));
  }

}
IndustryInput.defaultProps = {
  buttonUse: 'form',
  shouldUseRelevantSearch: false,
  predicted: false,
  predictedOptions: [],
  predictedSelectedValue: undefined,
  readOnly: false,
  onShowAll: () => {},
  shouldShowPlaceholder: true
};